import { render, staticRenderFns } from "./sourceOfPurchase.vue?vue&type=template&id=69349751&scoped=true&"
import script from "./sourceOfPurchase.vue?vue&type=script&lang=js&"
export * from "./sourceOfPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69349751",
  null
  
)

export default component.exports